import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { AnnotatedApiQueryMethod} from '@shared/utils/makeApiQuery';
import { API_QUERY_ANNOTATIONS } from '@shared/utils/makeApiQuery';

export const useApiQuery = <
  TArgs extends any[],
  TResult,
  TError = Error,
  TQueryKey extends QueryKey = QueryKey,
>(
  api: AnnotatedApiQueryMethod<TArgs, TResult, TQueryKey>,
  args: TArgs,
  options?: Partial<UseQueryOptions<TResult, TError, TResult, TQueryKey>>,
) => {
  const { queryKey } =
    typeof api[API_QUERY_ANNOTATIONS] === 'function'
      ? api[API_QUERY_ANNOTATIONS](...args)
      : api[API_QUERY_ANNOTATIONS];

  return useQuery({
    queryKey,
    queryFn: () => api(...args),
    ...(options ? options : {}),
  });
};
